
































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import {AccordionItem, AccordionType} from '@/components/accordion';

@Component({
	components: {
		'v-accordion-item': AccordionItem
	}
})
export default class AccordionGroup extends Vue {
	@Prop({default: true}) readonly isHeadline: boolean;
	@Prop({default: true}) readonly name: string;
	@Prop({required: true}) readonly data: AccordionType;
	@Prop({required: false, default: false}) readonly noToggle: boolean;
	@Prop({required: false, default: false}) readonly toggle: boolean;
	@Prop({required: false, default: ''}) readonly animatedCards: string;

	activeItem: number = 0;

	@Watch('toggle')
	onToggleChanged(newValue: boolean): void {
		if (!newValue) {
			return;
		}
		this.toggleAllExcept(0);
	}

	toggleAllExcept(index: number) {
		(this.$refs.items as HTMLElement[]).forEach((item: any, id: number) => {
			if (id !== index) {
				item.toggle(false);
			}
		});
	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}
	}
}
